import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Text } from 'grommet'
import { FormClose } from 'grommet-icons'
import styled, { css } from 'styled-components'
import IconButton from '../Button/IconButton'
import { deleteTabData, addNewTabData } from '../../redux/common/actions'
import { setCurrentTabIndex } from '../../redux/common/actions'
import { AbsoluteBox } from '../Common'

const disabledTab = css`
  cursor: default;
  color: ${props => props.theme.global.colors.disabled};
  &:hover {
    background-color: ${props => props.theme.global.colors.baseBackground};
  }
  pointer-events: none;
`

const menuStyle = css`
  position: relative;
  cursor: pointer;
  border: none;
  width: 100%;
  background-color: ${props =>
    props.active
      ? props.theme.global.colors.secondary
      : props.theme.global.colors.baseBackground};
  color: ${props =>
    props.active
      ? props.theme.global.colors.invertTextStrong
      : props.theme.global.colors.text};

  user-select: none;

  &:hover {
    background-color: ${props =>
      props.active
        ? props.theme.global.colors.secondary
        : props.theme.global.colors.hoverBg};
  }
  ${props => props.disabled && disabledTab}
`

const Tab = styled(Box)`
  flex-direction: row;
  height: 4.8rem;
  white-space: nowrap;
  align-items: center;
  justify-content: flex-start;
  padding: 0 1.5rem;
  ${menuStyle}
`

const CreateNewWheelTab = styled(Box)`
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0.7rem 1.5rem;
  ${menuStyle}
`

const WheelTabs = ({ page }) => {
  const { tabsData, currentTabIndex } = useSelector(state => state.common)
  const dispatch = useDispatch()

  return (
    <Box
      justify="start"
      align="stretch"
      width="20rem"
      background="baseBackground"
    >
      <CreateNewWheelTab
        onClick={() => {
          if (tabsData.length === 5) return
          dispatch(addNewTabData(page))
        }}
        disabled={tabsData.length === 5}
      >
        <Text weight={600} size="1.6rem" margin={{ bottom: '.2rem' }}>
          + Create New Wheel
        </Text>
        <Text size="1.2rem">
          Only the selected wheel is kept for next visit.
        </Text>
      </CreateNewWheelTab>
      {tabsData.map((tab, index) => {
        return (
          <Tab
            key={`WheelTab${index}`}
            active={index === currentTabIndex}
            onClick={() => {
              if (currentTabIndex !== index) {
                dispatch(setCurrentTabIndex(page, index))
              }
            }}
          >
            <span style={{ maxWidth: '100%' }}>
              {!!tab.name || !!tab.id
                ? `${tab.id}: ${tab.name}`
                : `Wheel ${tab.tabNumber}`}
            </span>
            {tabsData.length > 1 && (
              <AbsoluteBox
                width="20%"
                right="0"
                height="100%"
                top="0"
                align="center"
                justify="center"
                style={{
                  zIndex: 1,
                }}
              >
                <IconButton
                  icon={
                    <FormClose
                      size="18px"
                      color={
                        index === currentTabIndex ? 'invertTextStrong' : 'text'
                      }
                    />
                  }
                  onClick={event => {
                    event.stopPropagation()
                    dispatch(deleteTabData(page, index))
                  }}
                />
              </AbsoluteBox>
            )}
          </Tab>
        )
      })}
    </Box>
  )
}

export default WheelTabs
